import { StorageHlp } from 'src/lib/fliko/helpers/storage.helper';
import { FileInStorageVM } from '../models/file.data';

export class AttHlp {
  /**
   * Maps string[] to FileInStorageVM[]
   * ! @warning save this structure to component field to omit repaint loop
   * @param {string[] | undefined} array    table to map (string[])
   * @param {boolean}              isUrl    is table with firebase urls (true) or storage paths (false) - false by default
   * @param {boolean}              withName if name should be taken from url/path - true by default
   * @return {FileStorageData[]} to attachment and image displaying
   */
  public static toFileInStorageVM(array: string[] | null | undefined, isUrl: boolean = false): FileInStorageVM[] {
    const files: FileInStorageVM[] = [];

    array?.forEach((path) => {
      if (path) {
        const storagePath = isUrl ? StorageHlp.urlToPath(path) : path;
        files.push({
          downloadUrl: isUrl ? path : undefined,
          storagePath,
          name: StorageHlp.pathToName(storagePath)
        });
      }
    });

    return files;
  }

  /** @deprecated use toFileInStorageVM instead */
  public static toFileInStorageData = AttHlp.toFileInStorageVM;

  public static splitPaths(data: string | null | undefined, splitChar: string = '|'): string[] {
    return data ? data.split(splitChar).filter((x) => x.length > 0) : [];
  }
}
